module.exports = ".foo {\n  background: pink;\n}\n\n.bar {\n  color: purple;\n}\n"